import { p as promiseResolve, b as bootstrapLazy } from './index-53dab568.js';
/*
 Stencil Client Patch Esm v2.4.0 | MIT Licensed | https://stenciljs.com
 */

var patchEsm = function patchEsm() {
  return promiseResolve();
};

var defineCustomElements = function defineCustomElements(win, options) {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(function () {
    return bootstrapLazy([["ion-phaser", [[0, "ion-phaser", {
      "game": [1040],
      "initialize": [4],
      "getInstance": [64],
      "destroy": [64]
    }]]]], options);
  });
};

export { defineCustomElements };